import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('client_settings')
    .setAdditionalRoutes([
        'client_settings_create',
        'client_settings_edit',
    ]);
